import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductVariantFormat extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');

    this.section?.addEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    );
  }

  disconnectedCallback() {
    this.section?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    );
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    const { data } = event.detail;

    if (!data?.html) return;

    const newFormat = data.html.querySelector('product-variant-format');

    if (!newFormat) return;

    morph(this, newFormat);
  };
}

if (!customElements.get('product-variant-format')) {
  customElements.define(
    'product-variant-format',
    ProductVariantFormat
  );
}